import { Component, OnInit, OnDestroy } from '@angular/core';
import { trigger, transition, style, animate, keyframes} from '@angular/animations';
import { Constant } from '../../../environments/constants';
import { Subscription } from 'rxjs';
import { ContextService } from '../../services/context/context.service';
import { DataService } from '../../services/context/data.service';
import { UIStateService } from '../../services/context/uistate.service';
import { AppMonitoringService } from '../../services/util/app-monitoring.service';
import * as fromModel from '../../services/models';

import { EditExpenseComponent } from '../edit-expense/edit-expense.component';

import { MatDialog } from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import { Utils } from '../../../utils/utils';
import { RefDataService } from '../../services/context/ref-data.service';

@Component({
  selector: 'gp-goal-details',
  templateUrl: './goal-details.component.html',
  styleUrls: ['./goal-details.component.scss'],
  animations: [
    trigger(
      'modalFadeZoom',
      [
        transition(
          ':enter', [
            style({ transform: 'translateX(-50%) translateY(-50%) scale(.7)', opacity: 0 }),
            animate('0.3s', style({ opacity: 1, transform: 'translateX(-50%) translateY(-50%) scale(1)' })),
          ]
        ),
        transition(
          ':leave', [
            style({ opacity: 1, transform: 'translateX(-50%) translateY(-50%) scale(1)' }),
            animate('5.3s', style({ opacity: 0, transform: 'translateX(-50%) translateY(-50%) scale(.7)' })),
          ]
        ),
      ]),

      trigger('fadeSlideGrowKeyframe', [
        transition(':enter', [
          style({ opacity: 0, transform: 'scale(0.5) translateY(50px)' }),
          animate(
            '400ms',
            keyframes([
              style({ opacity: 1, offset: 0.3 }),
              style({ transform: 'translateY(0)', offset: 0.6 }),
              style({ transform: 'scale(1)', offset: 1 }),
            ])
          ),
        ]),
        transition(':leave', [
          style({ opacity: 1, transform: 'scale(-0.5) translateY(50px)' }),
          animate(
            '400ms',
            keyframes([
              style({ opacity: 0, offset: 0.3 }),
              style({ transform: 'translateY(0)', offset: 0.6 }),
              style({ transform: 'scale(1)', offset: 1 }),              
            ])
          ),
        ]),
      ])
  ]
})
export class GoalDetailsComponent implements OnInit, OnDestroy {

  protected _storeDataSubscription: Subscription;
  displayedColumns: string[] = ['select', 'expDesc', 'owner', 'amount', 'growthType', 'startYr', 'endYr', 'actions'];

  Expenses: any = [];
  SelectedExpenses: any = [];
  showDetails = false;

  selectedGoalId;
  selectedGoalSummary;
  
  //dataSource;
  dataSource = new MatTableDataSource<any>(this.Expenses);
  goalDataSource: fromModel.Goal[];
  selection = new SelectionModel<any>(true, []);

  goals = [];
  goalsRef: fromModel.CodeValue[] = [];
  
  planExpenses: fromModel.Expense[];
  
  constructor(private contextService:ContextService,
    private dataService:DataService,
    private uiStateService: UIStateService,
    private refDataService: RefDataService,
    private dialog: MatDialog, 
    private appMonitoringService: AppMonitoringService) {      
  }

  ngOnInit(): void {
    this._storeDataSubscription = this.dataService.subscribe((appData: fromModel.IAppData) => this.populateAppData(appData));      
    this.dataService.getGoalSummary();
    //this.populatePlanGoalsFromRefData();
    this.goalsRef  = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.Goals);
    this.populatePlanGoals()
    //this.goals = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.Goals);
    
  }

  private populateAppData(appData: fromModel.IAppData){
    //if(appData && (appData.action===fromModel.DATA_ACTION.PLAN || appData.action===fromModel.DATA_ACTION.UPDATEEXPENSE)){
    if(appData && appData.action!==fromModel.DATA_ACTION.NONE){
      this.populateExpenseList();
      this.populatePlanGoals();      
    }
  }

  private populateExpenseList(){
    this.planExpenses = this.dataService.getAllExpenses();
        let _expenses =  [];
        let expData;
        this.SelectedExpenses = [];
        if(this.planExpenses && this.planExpenses.length>0){
          this.planExpenses.forEach(exp => {
            expData = this.prepareExpenseData(exp);
            _expenses.push(expData);
            if(expData.isIncluded){
              this.SelectedExpenses.push(expData);
            }
            
              
          });
        }
        this.Expenses = _expenses;
        this.dataSource = new MatTableDataSource<any>(this.Expenses);
        this.selection = new SelectionModel<any>(true, this.SelectedExpenses);
        this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "ExpenseListComponent-populateExpenseList", false);
  }

  private populatePlanGoalsFromRefData(){
    this.goals = [];
    this.goalsRef.forEach(goalRef => {
      this.goals.push({goalType: goalRef.code, goalDesc: goalRef.value});
    });
  }

  // RefreshGoalExpenseChart(){
  //   this.selectedGoalId = this.selectedGoalId;
  // }

  private populatePlanGoals(){
    this.goals = [];
    let goalId='';
    let priority=0;
    let planGoals  = this.dataService.getAllGoals();

    if(this.goalsRef && planGoals){
      this.goalsRef.forEach(goalRef => {
        let _goal = planGoals.find(goal=>goal.goalType === goalRef.code);
        goalId = '';
        if(_goal){
          goalId = _goal.goalId;
          priority = _goal.priority;
        }
        this.goals.push({goalId: goalId, goalType: goalRef.code, goalDesc: goalRef.value, priority: priority});      
      });
  
      let goalsSummary = this.dataService.getGoalSummaryArray();
      
      if(goalsSummary){
  
      this.goals.forEach(goal => {
          let _g = goalsSummary.find(_goal=>_goal.goalId === goal.goalId);
          let _gPosition = goalsSummary.indexOf(_g);
          if(_g){
            _g.goalType = goal.goalType;
            _g.goalDesc = goal.goalDesc;
            _g.priority = goal.priority;
            this.goals[_gPosition] = _g;
          }
        });
      }

      if(this.selectedGoalId && !this.selectedGoalSummary){
        this.selectedGoalSummary = goalsSummary.find(_goal=>_goal.goalId === this.selectedGoalId);
      }
    }
    
    
  }

  private prepareExpenseData(expense: fromModel.Expense){
    
    let data = {
      expId: expense.expId,
      expDesc: expense.expDesc,
      owner: this.dataService.getPlanClientByClientId(expense.owner).clientname,
      growthType: this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.GrowthRates, expense.growthType).value,
      growthRate: expense.growthRate,
      startType: expense.amtPeriod[0].startType,
      startYr: expense.amtPeriod[0].startYr,
      endYr: expense.amtPeriod[0].endYr,
      endType: expense.amtPeriod[0].endType,
      amount: expense.amtPeriod[0].amount,
      isIncluded: expense.isIncluded,
    }
    return data;
  }

  editExpense(expenseId){
    //let expense: fromModel.Expense = this.dataService.getExpenseByExpenseId(expenseId);
    this.openModelDialog(fromModel.OPENDIALOGACTIONS.EDITEXPENSE, expenseId)
  }

  openModelDialog(action: fromModel.OPENDIALOGACTIONS, expenseId: string){
    switch(action){
      case fromModel.OPENDIALOGACTIONS.EDITEXPENSE: {
        const dialogRef = this.dialog.open(EditExpenseComponent, {
          width: '70%',
          height: '70%',
          data: expenseId,
          //data: expense,
          disableClose: true    
          }).afterClosed()
          .subscribe(result => {
            if(result && result.isSaved){
              //this.refreshExpense(result.expense);
            }
          });        
        break;
      }       
    }
  }

  // refreshExpense(expense: fromModel.Expense){
  //     const _exp = this.Expenses.find(exp=> exp.expId === expense.expId);
  //     if(_exp){
  //       const _expPosition = this.Expenses.indexOf(_exp);
  //       let expData = this.prepareExpenseData(expense);
  //       this.Expenses[_expPosition] = expData;   
  //       this.dataSource = new MatTableDataSource<any>(this.Expenses);   
  //       if(expData.isIncluded){
  //         this.SelectedExpenses.push(expData);
  //       }  
  //       this.selection = new SelectionModel<any>(true, this.SelectedExpenses);
  //     }
    
  // }

  showGoalExpense(goal){
    this.showDetails = true;
    this.selectedGoalSummary = goal;
    this.selectedGoalId = goal.goalId;
  }

  closeDetailsOverlay(){
    this.showDetails = false;
    this.selectedGoalSummary = null;
    this.selectedGoalId = '';
  }
  saveSelectedExpenses() {
      let selectedExpenses = [];
      this.selection.selected.forEach(s => selectedExpenses.push(s.expId));
      this.dataService.dispatchAction(fromModel.DATA_ACTION.SELECTEDEXPENSES, "ExpenseListComponent-saveSelectedExpenses", selectedExpenses);
      this.dataService.savePlan();
}

  masterToggle() {
    if(this.dataSource && this.dataSource.data && this.dataSource.data.length){
      this.isAllSelected() ?
          this.selection.clear() :
          this.dataSource.data.forEach(row => this.selection.select(row));
    }
  }

  isAllSelected() {
    if(this.dataSource && this.dataSource.data && this.dataSource.data.length){
      const numSelected = this.selection.selected.length;
      const numRows = this.dataSource.data.length;
      return numSelected === numRows;
    }
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }

  ngOnDestroy(): void{
    if(this._storeDataSubscription && this._storeDataSubscription !== null){
      this._storeDataSubscription.unsubscribe();
    }        
  }

}
